import React from "react";
import { Controls, IFormStyles, useFormStyles } from "../.";
import { FormGroup, FormGroupProps, FormGroupType } from "./formGroup";

interface FormAttachmentsProps extends Controls.ControlAttachmentsProps {
    isLoading?: boolean | undefined
    label?: string | undefined
    note?: string;  
    groupType?: FormGroupType | undefined;
    labelWidth?: string | undefined;
}

const ComponentProps = (props: FormAttachmentsProps): Controls.ControlAttachmentsProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.isLoading;
    delete componentProps.groupType;
    delete componentProps.labelWidth;

    delete componentProps.label;
    delete componentProps.note;
    delete componentProps.isOptional;
    delete componentProps.tooltip;

    return componentProps;
}

const GroupProps = (props: FormAttachmentsProps): FormGroupProps => {
    const groupProps: FormGroupProps = {
        controlStyles: props.controlStyles,
        isLoading: props.isLoading,
        disabled: props.disabled,
        groupType: props.groupType,
        labelWidth: props.labelWidth,

        label: props.label,
        note: props.note, 
        isOptional: props.isOptional,
        tooltip: props.tooltip,
    };

    return groupProps;
}

export const FormAttachments: React.FC<FormAttachmentsProps> = (props) => {
    const styles: IFormStyles = useFormStyles();
    
    return (
        <FormGroup  {...GroupProps(props)}>
            <Controls.ControlAttachments {...ComponentProps(props)} />
        </FormGroup>
    );
};
